import { render } from "./AdminRiderraterangeEdit.vue?vue&type=template&id=81f6102c&scoped=true&ts=true&lang=true"
import script from "./AdminRiderraterangeEdit.vue?vue&type=script&lang=ts"
export * from "./AdminRiderraterangeEdit.vue?vue&type=script&lang=ts"

import "./AdminRiderraterangeEdit.vue?vue&type=style&index=0&id=81f6102c&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81f6102c"]])

export default __exports__